<template>
  <div :class="classList">
    <label v-if="label"
      >{{ label.trim().replace(/\*$/, "") }}
      <span v-if="isRequired" class="asterisk-mark">*</span></label
    >
    <div
      v-if="adminDescription && $store.getters.isAgent"
      class="admin-description"
    >
      <div v-html="adminDescription"></div>
    </div>
    <div v-if="description" class="description">
      <div v-html="description"></div>
    </div>
    <div class="list-options-container">
      <div
        class="option-container"
        v-for="(option, index) in normalizedOptionList"
        :key="'option' + index"
      >
        <label class="checkbox-container">
          <img :src="normalizedIconList[index]" :alt="option" />
          <input
            class="form-check-input"
            type="radio"
            :value="option"
            :id="'radio-' + name + index"
            :checked="isCheck(option, index)"
            @change="handleOnChange(option, index)"
            :disabled="isDisabled"
          />
          <span class="checkmark"></span>
          <div class="option-label">{{ getDisplayOption(option) }}</div>
        </label>
      </div>
    </div>
    <div v-if="bottomDescription" class="description">
      <div v-html="bottomDescription"></div>
    </div>
    <p
      class="required-message"
      v-if="(value == null || value === '') && submitClicked && isRequired"
    >
      {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
    </p>
  </div>
</template>
<script>
/* This component includes a label, and a radio group, which includes radio buttons and its label
Any error of the radio group (for example: required field) is showed in this component */
export default {
  name: "RadioIconGroup",
  props: {
    /* Name of the radio component, it is used in id of each radio button,
    therefore it need to be different between RadioGroup component */
    name: String,
    // Label at the top of component
    label: String,
    // Description which are only visible to admin
    adminDescription: String,
    // Description below label
    description: String,
    // Description below all options
    bottomDescription: String,
    // Input value, which is used for v-model
    value: [String, Boolean],
    // List of class to style for component, each class is separated by space
    classList: {
      type: String,
      default: "col-lg-12",
    },
    // List of options for radio buttons (the label of each radio buttons)
    optionList: {
      type: [Array, String],
      default: () => ["Yes", "No"],
    },
    iconList: String,
    hasOther: {
      type: Boolean,
      default: false,
    },
    // Index of default selected option
    defaultValue: [Number, String],
    // true if submit button is clicked, it is used to show 'required' error
    submitClicked: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    // field will be saved by boolean_selector
    isBooleanModel: {
      type: Boolean,
      default: false,
    },
    // Display options in multiple columns
    numberOfColumn: {
      type: Number,
      default: 1,
    },
    // Map option list to display in multiple languages
    mapOptionListByLang: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    if (!this.hasOther && this.value) {
      // Reset value if it is not included in option list
      if (!this.normalizedOptionList.includes(this.value)) {
        this.$emit("input", null);
      }
    }
    if (this.defaultValue != null && this.value == null) {
      this.$emit("input", this.normalizedOptionList[this.defaultValue]);
    }
  },
  // created() {
  //   this.$emit("input", this.normalizedOptionList[0]);
  // },
  computed: {
    normalizedOptionList() {
      if (Array.isArray(this.optionList)) {
        return this.optionList;
      }
      return this.optionList
        .split("\n")
        .map((option) => option.trim())
        .filter((option) => option.length > 0);
    },
    normalizedIconList() {
      if (Array.isArray(this.iconList)) {
        return this.iconList;
      }
      return this.iconList
        .split("\n")
        .map((option) => option.trim())
        .filter((option) => option.length > 0);
    },
    getOtherValue() {
      if (!this.optionListExcludeOther.includes(this.value)) {
        return this.value;
      }
    },
    optionListExcludeOther() {
      return this.normalizedOptionList.slice(0, -1);
    },
    optionsPerColumn() {
      if (this.normalizedOptionList == null) {
        return 0;
      }
      if (!this.numberOfColumn) {
        return this.normalizedOptionList.length;
      }
      return Math.ceil(this.normalizedOptionList.length / this.numberOfColumn);
    },
    columnClass() {
      if (this.numberOfColumn == null || this.numberOfColumn === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / this.numberOfColumn);
    },
  },
  methods: {
    getOptionId(index) {
      return `Radion-Option-${this.name}-${index}`;
    },
    isCheck(option, index) {
      if (this.isBooleanModel) {
        if (this.value === true) {
          return option === "Yes";
        } else if (this.value === false) {
          return option === "No";
        }
      } else {
        if (this.hasOther && this.value != null) {
          if (index === this.normalizedOptionList.length - 1) {
            if (!this.optionListExcludeOther.includes(this.value)) {
              return true;
            }
          }
        }
        return option === this.value;
      }
    },
    handleOnChange(option, index) {
      console.log("onChange", option, index);
      if (this.isBooleanModel) {
        this.$emit("input", option === "Yes");
      } else {
        if (this.hasOther && index === this.normalizedOptionList.length - 1) {
          this.$emit("input", "");
        } else {
          this.$emit("input", option);
        }
      }
    },
    handleOtherTextboxInput(event) {
      this.$emit("input", event.target.value);
    },
    getDisplayOption(option) {
      if (!this.mapOptionListByLang) {
        return option;
      }
      if (this.mapOptionListByLang[option]) {
        return this.mapOptionListByLang[option];
      }
      return option;
    },
  },
};
</script>
<style scoped>
.option-container img {
  width: 80px;
  height: 80px;
  border: 3px solid #b6b6b6;
  border-radius: 16px;
}

.checkbox-container > .checkmark {
  border-radius: 50%;
  position: absolute;
  top: 63px;
  background-color: white;
  border: 3px solid #b6b6b6;
  height: 28px;
  width: 28px;
  left: 0;
  right: 0;
  margin: auto;
}

.checkbox-container {
  padding-left: 0;
  text-align: center;
  position: relative;
}

.option-label {
  font-weight: 700;
  margin-top: 0.5em;
}

.list-options-container {
  display: flex;
  flex-wrap: wrap;
}

.option-container {
  flex-basis: 80px;
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/common/form-elements/RadioIconGroup.vue